import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  storeSpecialModelTest ( {dispatch}, obj) {
    return new Promise((resolve, reject) => {
      axios.post('createSpecialModelTest', obj)
        .then(response => {
          resolve(response.data)
          dispatch('GetSpecialModelTestList')
        }).catch((err) => {
          reject(err)
        })
    })
  },
  GetSpecialModelTestList ({commit}) {
    axios.get('get-special-model-list-admin')
    .then(response => {   
      commit('setSpecialModelTestList', response.data)
    })
  },
}
